import { FunctionComponent } from "react";
import {
  PurchaseOrderProvider,
  usePurchaseOrder,
} from "../contexts/po-creation-context";
import PurchaseOrderCreateScreen from "./purchase_order_create_screen";
import PurchaseOrderUpdateScreen from "./purchase_order_update_screen";
import PurchaseOrderDetailScreen from "./purchase_order_detail_screen";
import PurchaseOrderApprovalScreen from "../purchase_order_approval/purchase_order_approval_screen";
import { POType, PurchaseOrderModelV2 } from "../model/purchase_order_model";
import PurchaseOrderReorderScreen from "./purchase_order_reorder";
import PurchaseOrderJobWorkCreateScreen from "./purchase_order_job_work_create_screen";
import PurchaseOrderRevisedScreen from "./purchase_order_revised_screen";

interface RevisedPOCreatePageProps {}

export const RevisedPOCreatePageWrapper: FunctionComponent<
  RevisedPOCreatePageProps
> = () => {
  return (
    <>
      <PurchaseOrderProvider>
        <PurchaseOrderRevisedScreen />
      </PurchaseOrderProvider>
    </>
  );
};

interface POCreatePageProps {}

export const POCreatePageWrapper: FunctionComponent<POCreatePageProps> = () => {
  return (
    <PurchaseOrderProvider>
      <POCreateInner />
    </PurchaseOrderProvider>
  );
};

const POCreateInner = () => {
  const { purchaseOrder } = usePurchaseOrder();

  return purchaseOrder.type === POType["Job Work PO"] ? (
    <PurchaseOrderJobWorkCreateScreen />
  ) : (
    <PurchaseOrderCreateScreen />
  );
};

interface POUpdatePageProps {}

export const POUpdatePageWrapper: FunctionComponent<POUpdatePageProps> = () => {
  return (
    <>
      <PurchaseOrderProvider>
        <PurchaseOrderUpdateScreen />
      </PurchaseOrderProvider>
    </>
  );
};

interface PODetailPageProps {}

export const PODetailPageWrapper: FunctionComponent<PODetailPageProps> = () => {
  return (
    <>
      <PurchaseOrderProvider>
        <PurchaseOrderDetailScreen />
      </PurchaseOrderProvider>
    </>
  );
};

interface POApprovePageProps {}

export const POApprovePageWrapper: FunctionComponent<
  POApprovePageProps
> = () => {
  return (
    <>
      <PurchaseOrderProvider>
        <PurchaseOrderApprovalScreen />
      </PurchaseOrderProvider>
    </>
  );
};

interface ReorderPageProps {
  purchaseOrder: PurchaseOrderModelV2;
}

export const PurchaseOrderReorderPageWrapper: FunctionComponent<
  ReorderPageProps
> = ({ purchaseOrder }) => {
  return (
    <PurchaseOrderProvider>
      <PurchaseOrderReorderScreen />
    </PurchaseOrderProvider>
  );
};
